import React from "react";
import get from "lodash/get";

import StarRating from "../../../atoms/star-rating";

import "./gadget-review.m.css";

const GadgetReviewView = ({ story }) => {
  const MetaData = get(story, ["metadata"]);
  const gadgetName = get(MetaData, ["gadget-name"], "");
  const feature1 = get(MetaData, ["feature1"], "");
  const feature2 = get(MetaData, ["feature2"], "");
  const feature3 = get(MetaData, ["feature3"], "");
  const rating = get(MetaData, ["gadget-rating"], "");

  if (gadgetName === "" && feature1 === "" && feature2 === "" && feature3 === "" && rating === "") {
    return null;
  }
  const isFeatureAvailable = feature1.length > 0 || feature2.length > 0 || feature3.length > 0;

  return (
    <div styleName="wrapper">
      <div styleName="text-and-rating">
        <div styleName="title-wrapper">
          <div styleName="title">{gadgetName}</div>
        </div>
        {rating.length > 0 && <StarRating rating={rating} />}
      </div>
      {isFeatureAvailable && <div styleName="top-features">ಪ್ರಮುಖ ವೈಶಿಷ್ಟ್ಯಗಳು</div>}
      <ul styleName="details">
        {feature1.length > 0 && (
          <li>
            <div styleName="disc"></div>
            {feature1}
          </li>
        )}
        {feature2.length > 0 && (
          <li>
            <div styleName="disc"></div>
            {feature2}
          </li>
        )}
        {feature3.length > 0 && (
          <li>
            <div styleName="disc"></div>
            {feature3}
          </li>
        )}
      </ul>
    </div>
  );
};

export default GadgetReviewView;
